/** Momento dell'ultimo dato scaricato dal server (per il messaggio "dati al …"). */
const KEY = "kilolava.lastSync";
const listeners = new Set();

export function markSync(ts = Date.now()) {
  try { localStorage.setItem(KEY, String(ts)); } catch { /* ignore */ }
  listeners.forEach((fn) => fn(ts));
}

export function getLastSync() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? Number(raw) : null;
  } catch {
    return null;
  }
}

export function onSync(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function formatLastSync(ts) {
  if (!ts) return null;
  const d = new Date(ts);
  const today = new Date();
  const sameDay = d.toDateString() === today.toDateString();
  const time = d.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
  if (sameDay) return `oggi ${time}`;
  return `${d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit" })} ${time}`;
}
